import { Component } from '@angular/core';

@Component({
    selector: 'black-payment-success',
    templateUrl: './payment-success.component.html',
    styleUrls: ['./payment-success.component.css'],
    standalone: false
})
export class PaymentSuccessComponent {}
